export default __webpack_public_path__ + "static/media/arbitrage-fund-passcode.e5bbc1d9.jpg";